module.exports = __webpack_public_path__ + "static/media/SIX.cafd47a5.png";